import { useEffect, useMemo, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as Icons from "@fortawesome/free-brands-svg-icons";
import _ from "underscore";
import { useLocation, useNavigate } from "react-router-dom";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";

export const useRequestPopup = ({ type }) => {

    const [requestTypes, setRequestTypes] = useState([]);
    const [selectedType, setSelectedType] = useState(null);
    const [options, setOptions] = useState({});
    const navigate = useNavigate();
    const { pathname } = useLocation();

    useEffect(() => {
        callautopopulate("request_types", "projects", "project_roles", "project_request_type", "admin_users", "users", "build_type", "user_info").then((res) => {
            res?.request_types?.forEach((data) => {
                const requestTypeKey = data.request_type_key;
                if (['/help-desk-git', '/help-desk-vpn', '/help-desk-jenkins', '/help-desk-prod-build'].includes(pathname) && ['git_tab', 'vpn_tab', 'jenkins_tab', 'prod_service_build_tab'].includes(requestTypeKey)) {
                    data['view'] = true;
                    data['request_type_icon'] = getRequestTypeIcons(requestTypeKey);
                }
                else if (['/help-desk-prod-server', '/help-desk-logs'].includes(pathname) && ['server_access_tab', 'logs_tab'].includes(requestTypeKey)) {
                    data['view'] = true;
                    data['request_type_icon'] = getRequestTypeIcons(requestTypeKey);
                }
                else if (['/help-desk-project-access'].includes(pathname) && ["project_access_tab"].includes(requestTypeKey)) {
                    data['view'] = true;
                    data['request_type_icon'] = getRequestTypeIcons(requestTypeKey);
                }
                else {
                    data['request_type_icon'] = getRequestTypeIcons(requestTypeKey);
                }
            });
            setRequestTypes(res?.request_types);
            const currentActive = _.findWhere(res?.request_types, { request_type_key: type })
            setSelectedType(currentActive)
            setOptions({
                projects: _.sortBy(_.uniq(res.projects, (item) => item.project_id), "project_name"),
                projectRole: _.sortBy(_.uniq(res.project_roles, (item) => item.project_role_id), "project_role_name"),
                action: _.sortBy(_.uniq(res.project_request_type, (item) => item.request_type_id), "request_type_name"),
                requestTo: _.sortBy(_.uniq(res.admin_users, (item) => item.user_code), "user_display_name"),
                assignedTo: _.sortBy(_.uniq(res?.users, (item) => item.user_code), "user_display_name"),
                prod_build_types: _.sortBy(res?.build_type, "build_type_name"),
                userInfo: res?.user_info[0]
            })
        }).catch((error) => {
            console.error("error", error)
        })

    }, [type]);

    useEffect(() => {
        selectedType?.request_type_name?.toLowerCase() === "project access" && getUserProjects()
    }, [selectedType])
    const getUserProjects = async () => {
        try {
            const res = await services.getInvokeRemote("GET", Urls("GETALLPROJECTS"));
            if (res?.body?.data) {
                setOptions((prev) => ({ ...prev, allProject: _.sortBy(res.body.data.userprojects, "project_name") }))

            }
        } catch (error) {
            console.error("Error getting project list: ", error);
        }
    };

    const getRequestTypeIcons = (name) => {
        switch (name) {
            case "git_tab":
                return <FontAwesomeIcon icon={Icons.faGitlab} className="help-desk-icons" />;
            case "vpn_tab":
                return <img src="./assets/vpn_icon.png" width={27} height={27} />;
            case "server_access_tab":
                return <FontAwesomeIcon icon="fa-solid fa-database" className="help-desk-icons" />;
            case "jenkins_tab":
                return <FontAwesomeIcon icon={Icons.faJenkins} className="help-desk-icons" />;
            case "logs_tab":
                return <FontAwesomeIcon icon="fa-solid fa-gear" className="help-desk-icons" />;
            case "project_access_tab":
                return <FontAwesomeIcon icon="fa-solid fa-users-gear" className="help-desk-icons" />
            case "prod_service_build_tab":
                return <FontAwesomeIcon icon="fa-solid fa-screwdriver-wrench" className="help-desk-icons" />
            default:
                return <FontAwesomeIcon icon="fa-solid fa-gear" className="help-desk-icons" />;
        }
    }



    return useMemo(() => ({
        requestTypes, selectedType, setSelectedType, options, navigate, pathname
    }), [requestTypes, selectedType, setSelectedType, options, navigate, pathname])
}